
<nz-input-group nzSearch nzPrefixIcon="search" [nzAddOnAfter]="suffixIconButton">
  <input nz-input [(ngModel)]="searchKey" [placeholder]="'search.field'|translateTA" (keyup)="search($event)" 
  (keydown.enter)="onEnter()"/>
</nz-input-group>
<ng-template #suffixIconButton>
      <button nz-button nzType="primary" nzSearch (click)="onEnter()" nz-tooltip nzTooltipTitle="{{'json.form.search.tooltip'|translateTA}}">
        <nz-icon nzType="search" />
      </button>
</ng-template>
 <mat-divider style="margin-top: 10px;"></mat-divider>
<div class="form-json-container"> 
  <nz-card [nzTitle]="title|translateTA:{fieldname:main}">
    <json-forms-node-new [data]="jsonData" [path]="[]" (userChanging)="changingValueEvent()"></json-forms-node-new>
  </nz-card>

  <!--button nz-button nzType="primary" (click)="exportJson()">Export JSON</button-->
  <div class="jsonviewer-container">
    <json-viewer [json]="jsonString" (jsonChange)="onChangeJson($event)" [readOnly]="false"></json-viewer>
  </div>
</div>
 <mat-divider></mat-divider>
 <div class="buttons-action">
        <p class="link" *ngIf="json_original!=null" (click)="recover()">{{'recover.original'|translateTA}}</p>
        <div class="buttons">
          <button nz-button nzType="primary" class="orange-button" (click)="exportJson()">{{'export'|translateTA}}</button>
           <mat-divider vertical="true"></mat-divider>
          <button nz-button nzType="primary"  (click)="submit()">{{'save'|translateTA}}</button>
          <button nz-button nzType="primary" nzDanger  (click)="cancel()">{{'cancel'|translateTA}}</button>
        </div>
  </div>